import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

export const isLoadingSelector = (statusKey) => (state) => state.risks[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.risks[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectRisks = (state) => state.risks?.risks;
export const selectRisksLoading = isLoadingSelector('risksStatus');

export const selectTotalRisks = (state) => state.risks?.totalRisks;

export const selectSearchRisksResults = (state) => state.risks?.searchRisksResults;
export const selectSearchRisksLoading = isLoadingSelector('searchRisksStatus');

export const selectExportRisksLoading = isLoadingSelector('exportRisksStatus');
export const selectExportRisksFailed = isFailedSelector('exportRisksStatus');

export const selectLastVisitedRiskId = (state) => state.risks?.lastVisitedRiskId;
